module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_4.23791a20.jpg";